import { Component, input } from '@angular/core';

/**
 * The centred "nothing here yet" card of a landing page: a heading, an
 * optional hint, and whatever action (e.g. a create button) the host projects.
 *
 * It has no i18n scope of its own: pass `title` and `hint` pre-translated, and
 * the projected content's `i18n` pipes resolve in the host's scope. The hint is
 * an input rather than projected because projected nodes keep the host's style
 * scope, so this card's `p` style wouldn't reach them.
 */
@Component({
  selector: 'app-empty-state-card',
  templateUrl: './empty-state-card.html',
  styleUrl: './empty-state-card.scss',
})
export class EmptyStateCard {
  readonly title = input.required<string>();
  readonly hint = input<string | null>(null);
}
